import { render, staticRenderFns } from "./IconsMain.vue?vue&type=template&id=1e6fd869&"
import script from "./IconsMain.vue?vue&type=script&lang=js&"
export * from "./IconsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports